import { parse, serialize } from "parse5";

// Parse user HTML and inject a `data-fp-line` attribute (source line number) onto
// every element that has a known source location. This lets the sandboxed preview
// report the EXACT source line that produced a rendered element, instead of doing a
// fuzzy text search. Serialization is faithful for normal HTML; on parse failure we
// return the original code so the preview still renders.
export function injectSourceLineAttrs(html) {
  try {
    const doc = parse(html, { sourceCodeLocationInfo: true });
    const visit = (node) => {
      if (
        node.tagName &&
        node.sourceCodeLocation &&
        typeof node.sourceCodeLocation.startLine === "number"
      ) {
        const line = node.sourceCodeLocation.startLine;
        node.attrs = node.attrs || [];
        if (!node.attrs.some((a) => a.name === "data-fp-line")) {
          node.attrs.push({ name: "data-fp-line", value: String(line) });
        }
      }
      if (node.childNodes) node.childNodes.forEach(visit);
    };
    visit(doc);
    return serialize(doc);
  } catch (e) {
    return html;
  }
}
